// biome-ignore lint/complexity/noStaticOnlyClass: <explanation>
export class StructureValidator {
    static validate(application, skippedErrors = []) {
        const modelValidator = new ApplicationValidator(application);
        const modelErrors = modelValidator.validate();
        const allErrors = [...modelErrors];
        if (skippedErrors.length === 0) {
            return allErrors;
        }
        return allErrors.filter(err => !skippedErrors.some(rule => err.code === rule.code && (!rule.path || err.path.join('.') === rule.path)));
    }
}
class ApplicationValidator {
    constructor(model) {
        Object.defineProperty(this, "model", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: model
        });
    }
    validate() {
        const errors = [];
        return errors;
    }
}
//# sourceMappingURL=StructureValidator.js.map